import React from 'react';

import AddressSelectWidget from '@/orderForm/widgets/AddressSelectWidget';
import HiddenStatusDocusignWidget from '@/orderForm/widgets/HiddenStatusDocusignWidget';
import MultipleCheckboxes from '@/orderForm/widgets/MultipleCheckboxes';
import MultipleRadioWidget from '@/orderForm/widgets/MultipleRadioWidget';
import RadioWidget from '@/orderForm/widgets/RadioWidget';
import CustomWidgetArea from '@/orderForm/widgets/RequestFormWidgetArea';
import CustomWidgetAreaDisable from '@/orderForm/widgets/RequestFormWidgetAreaDisable';
import CustomWidgetCheckbox from '@/orderForm/widgets/RequestFormWidgetCheckbox';
import CustomWidgetNumber from '@/orderForm/widgets/RequestFormWidgetNumber';
import CustomWidgetPrice from '@/orderForm/widgets/RequestFormWidgetPrice';
import CustomWidgetPriceArea from '@/orderForm/widgets/RequestFormWidgetPriceArea';
import CustomWidgetPriceString from '@/orderForm/widgets/RequestFormWidgetPriceString';
import CustomWidgetString from '@/orderForm/widgets/RequestFormWidgetString';
import CustomWidgetStringMultiline from '@/orderForm/widgets/RequestFormWidgetStringMultiline';
import ZipcodeWidget from '@/orderForm/widgets/ZipcodeWidget';

const makeWidgets = ({ country } = {}) => {
  const useTextInputForAddress = ['UY', 'PY', 'MX', 'CO'].includes(country);

  return {
    customNumberWidget: CustomWidgetNumber,
    customStringWidget: CustomWidgetString,
    zipcodeWidget: ZipcodeWidget,
    radioWidget: RadioWidget,
    radio: RadioWidget,
    customPriceWidget: CustomWidgetPrice,
    customPriceAreaWidget: CustomWidgetPriceArea,
    customPriceStringWidget: CustomWidgetPriceString,
    customMultilineWidget: CustomWidgetStringMultiline,
    customAreaWidget: CustomWidgetArea,
    customAreaDisableWidget: CustomWidgetAreaDisable,
    customWidgetCheckbox: CustomWidgetCheckbox,
    hiddenDocuSignStatus: HiddenStatusDocusignWidget,
    MultipleCheckboxes,
    checkboxes: MultipleCheckboxes,
    multipleRadioWidget: MultipleRadioWidget,
    addressStateSelectWidget: useTextInputForAddress ? CustomWidgetString : AddressSelectWidget,
    addressCitySelectWidget: useTextInputForAddress ? CustomWidgetString : AddressSelectWidget,
    addressNeighborhoodSelectWidget: useTextInputForAddress ? CustomWidgetString : AddressSelectWidget,
    accessInformationAddressStateSelectWidget: useTextInputForAddress ? CustomWidgetString : AddressSelectWidget,
    accessInformationAddressCitySelectWidget: useTextInputForAddress ? CustomWidgetString : AddressSelectWidget,
    accessInformationAddressNeighborhoodSelectWidget: useTextInputForAddress ? CustomWidgetString : AddressSelectWidget,
    accessInformationKeysDevolutionAddressStateSelectWidget: useTextInputForAddress ? CustomWidgetString : AddressSelectWidget,
    accessInformationKeysDevolutionAddressCitySelectWidget: useTextInputForAddress ? CustomWidgetString : AddressSelectWidget,
    accessInformationKeysDevolutionAddressNeighborhoodSelectWidget: useTextInputForAddress ? CustomWidgetString : AddressSelectWidget,
    propertyAccessAddressStateSelectWidget: useTextInputForAddress ? CustomWidgetString : AddressSelectWidget,
    propertyAccessAddressCitySelectWidget: useTextInputForAddress ? CustomWidgetString : AddressSelectWidget,
    propertyAccessAddressNeighborhoodSelectWidget: useTextInputForAddress ? CustomWidgetString : AddressSelectWidget,
    propertyAccessKeysDevolutionAddressStateSelectWidget: useTextInputForAddress ? CustomWidgetString : AddressSelectWidget,
    propertyAccessKeysDevolutionAddressCitySelectWidget: useTextInputForAddress ? CustomWidgetString : AddressSelectWidget,
    propertyAccessKeysDevolutionAddressNeighborhoodSelectWidget: useTextInputForAddress ? CustomWidgetString : AddressSelectWidget,
    desiredPropertyAddressStateSelectWidget: useTextInputForAddress ? CustomWidgetString : AddressSelectWidget,
    desiredPropertyAddressCitySelectWidget: useTextInputForAddress ? CustomWidgetString : AddressSelectWidget,
    desiredPropertyAddressNeighborhoodSelectWidget: useTextInputForAddress ? CustomWidgetString : AddressSelectWidget,
    mainSuitorAddressStateSelectWidget: useTextInputForAddress ? CustomWidgetString : AddressSelectWidget,
    mainSuitorAddressCitySelectWidget: useTextInputForAddress ? CustomWidgetString : AddressSelectWidget,
    mainSuitorAddressNeighborhoodSelectWidget: useTextInputForAddress ? CustomWidgetString : AddressSelectWidget,
  };
};

export default makeWidgets;
